import { generateRootObjectSchema } from "components/cards/common/schema";
import { BaseParticleSpec, GetParticlePropsType, GetParticleSchemaType, generateParticleContainerSchema } from "components/cards/particles/BaseParticleSpec";
import { ImageParticleSpec } from "../../Core/Image/spec";
import { TextParticleSpec } from "../../Core/Text/spec";
import { ButtonParticleSpec } from "../../Core/Button/spec";

export const PlaylistParticleSpec = new BaseParticleSpec("Playlist Particle", generateRootObjectSchema({
  container: generateParticleContainerSchema({
    defaultValues: { fillHeight: false, fillWidth: false }
  }),
  playlistTitle: TextParticleSpec.generateSchema("Playlist Header Text", "Text displayed in the header of the playlist", {
    defaultValues: {
      container: { padding: '.9rem 2rem'},
      text: 'Up next',
      transform: 'uppercase',
      size: '1.5em',
      weight: '600'
    }
  }),
  activeIcon: ImageParticleSpec.generateSchema("Active Favorite Icon", "Icon for the active playlist item", {
    defaultValues: {
      container: { width: '1.5rem', height: '1.5rem', margin: '0px 6px 0px 0px' },
      icon: 'yc_icon_chevron_right',
      iconColor: 'white'
    }
  }),
  removeFavorite: ButtonParticleSpec.generateSchema("Remove From Playlist Button", "Button to remove favorite from playlist", {
    defaultValues: {
      image: {
        container: { width: '1.5rem', height: '1.5rem', margin: '0px 6px 0px 0px' },
        icon: 'yc_icon_close',
        iconColor: 'white'
      }
    }
  }),
  thumbnail: ImageParticleSpec.generateSchema("Playlist Thumbnail Image", "Image for a playlist video item", {
    defaultValues: {
      container: { width: '160px', height: '90px' },
    }
  }),
  favoriteTitle: TextParticleSpec.generateSchema("Favorite Title", "Title of the favorited item", {
    defaultValues: { lineClamp: 2, size: '14px', weight: '600' }
  }),
  publishDate: TextParticleSpec.generateSchema("Publish Date Text", "Text of the favorited item publish date", {
    defaultValues: { container: { margin: '6px 0px 0px 0px' }, size: '14px' }
  }),
  dateIcon: ImageParticleSpec.generateSchema("Publish Date Icon", "Icon displayed before the publish date", {
    defaultValues: {
      container: { width: '1rem', height: '1rem', margin: '6px 8px 0px 0px' },
      icon: 'yc_icon_clock',
      iconColor: 'white'
    }
  }),
  emptyPlaylistText: TextParticleSpec.generateSchema("Empty Playlist Text", "Text shown when the playlist is empty", {
    defaultValues: { 
      container: { padding: '1rem' },
      size: '14px', 
      weight: '600', 
      color: 'white', 
      text: 'Your playlist is looking a little empty! Add a video to get started.' }
  })
}));

export const specification = PlaylistParticleSpec;

export type PlaylistParticleSchema = GetParticleSchemaType<typeof PlaylistParticleSpec>;

export type PlaylistParticleProps = GetParticlePropsType<typeof PlaylistParticleSpec>;
